import { render, staticRenderFns } from "./NinteyNumberBoard.vue?vue&type=template&id=87768088&scoped=true&"
import script from "./NinteyNumberBoard.vue?vue&type=script&lang=js&"
export * from "./NinteyNumberBoard.vue?vue&type=script&lang=js&"
import style0 from "./NinteyNumberBoard.vue?vue&type=style&index=0&id=87768088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87768088",
  null
  
)

export default component.exports